var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"registration-banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xx-lg-10 col-xx-lg-offset-2 col-xs-12"},[_c('h1',{staticClass:"registration-banner__title"},[_vm._v("Реєстрація")])])])])])
}]

export { render, staticRenderFns }